var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13906 0 0 3.13906 0 7C0 10.8609 3.13906 14 7 14C10.8609 14 14 10.8609 14 7C14 3.13906 10.8609 0 7 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94717 4.98226L9.02844 4.05332C8.95813 3.98223 8.84413 3.98223 8.77372 4.05332L7 5.84694L5.22618 4.05341C5.15587 3.98232 5.04187 3.98232 4.97147 4.05341L4.05273 4.98236C3.98242 5.05345 3.98242 5.16872 4.05273 5.2399L5.82664 7.03333L4.05283 8.82686C3.98252 8.89795 3.98252 9.01322 4.05283 9.0844L4.97156 10.0133C5.04187 10.0844 5.15587 10.0844 5.22628 10.0133L7 8.21973L8.77382 10.0133C8.84413 10.0843 8.95813 10.0843 9.02853 10.0133L9.94727 9.08431C10.0176 9.01322 10.0176 8.89795 9.94727 8.82676L8.17336 7.03333L9.94717 5.23981C10.0176 5.16881 10.0176 5.05345 9.94717 4.98226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.3cd9312cd85530abdac75d1cde0b6fa0.svg";
export { ForwardRef as ReactComponent };